<template>
  <v-footer class="pa-3 mb-2">
    <dialog-loader d-title="Terms &amp; Conditions" content-url="https://www.gungho.com/terms-conditions/#copyright">
      <a class="mr-4">&copy; {{year}} Gung-Ho</a>
    </dialog-loader>
    <dialog-loader d-title="Terms &amp; Conditions" content-url="https://www.gungho.com/terms-conditions/">
      <a class="mr-4">Terms</a>
    </dialog-loader>
    <dialog-loader d-title="Privacy Policy" content-url="https://www.gungho.com/privacy-policy/">
      <a class="mr-4">Privacy</a>
    </dialog-loader>
    <v-spacer></v-spacer>
    <a target="_blank" href="https://www.gungho.com/genie/">Powered by GENIE</a>
  </v-footer>
</template>

<script>
  import DialogLoader from '../widgets/dialog-loader'

  export default {
    components: {
      dialogLoader: DialogLoader
    },

    computed: {
      year () {
        return new Date().getFullYear()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// footer-menu.vue?f33f4e58